import { RouteObject } from "react-router-dom";
import ErrorBoundary from "@/components/layout/ErrorBoundary";
import AiMusicPackageControl from "@/pages/ai-music/AiMusicPackageControl";

export const aiMusicRoutes: RouteObject[] = [
  {
    path: "/ai-music",
    children: [
      {
        path: "packages",
        element: <AiMusicPackageControl />,
        errorElement: <ErrorBoundary />
      }
    ]
  }
];
